import React from 'react';
import './DeliveryProgressBar.scss';
import dayjs from 'dayjs';

export default function DeliveryProgressBar({
  statuses,
}: {
  statuses: { title: string; createdAt: string }[];
}): JSX.Element {
  return (
    <div className="delivery-progress-bar">
      {statuses.map(status => (
        <div className={status.createdAt ? 'active' : ''} key={status.title}>
          {status.title}
          {status.createdAt &&
            ` (${dayjs(status.createdAt).format('HH:mm DD.MM.YY')})`}
        </div>
      ))}
    </div>
  );
}
